import { faPen, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'react-bootstrap';
import { Columns } from './types/Columns';

const createColumn = ({
  accessor,
  Header,
  pdfWidth,
  web = true,
  customEditOptions,
  filters,
  formatNumber,
}: Columns) => ({
  name: accessor,
  label: Header,
  pdfWidth,
  Header,
  accessor,
  customEditOptions,
  web,
  filters,
  formatNumber,
});

interface OriginalData {
  [key: string]: string;
}

export const formTables = {
  infractor: (
    onEdit: (index: number, invType: string) => void,
    onDelete: (index: number, invType: string) => void,
    readOnly = false,
    isBasename: boolean
  ) => {
    return [
      {
        ...createColumn({ accessor: 'invNombre', Header: 'Nombre completo' }),
        Cell: ({
          cell: {
            row: { original },
          },
        }: {
          cell: { row: { original: { invNombre: string; invApellido: string } } };
        }) => (
          <>
            {original.invNombre}&nbsp;{original.invApellido}
          </>
        ),
      },
      createColumn({ accessor: 'invPuestoRelacion', Header: 'Puesto' }),

      ...(isBasename
        ? [
          createColumn({ accessor: 'invUbicacion', Header: 'Ubicación' }),
          createColumn({ accessor: 'invTelMovil', Header: 'Teléfono móvil' }),
        ]
        : []),
      ...(readOnly
        ? []
        : [
          {
            ...createColumn({ accessor: 'customEdit', Header: 'Acciones' }),
            Cell: ({
              cell: {
                row: { original, index },
              },
            }: {
              cell: { row: { index: number; original: OriginalData } };
            }) => {
              console.log({ isBasename });
              return (
                <>
                  <Button type="submit" variant="link" onClick={() => onEdit(index, original.tipoInvolucrado)}>
                    <FontAwesomeIcon icon={faPen} />
                  </Button>
                  <Button type="submit" variant="link" onClick={() => onDelete(index, original.tipoInvolucrado)}>
                    <FontAwesomeIcon icon={faTrash} color="red" />
                  </Button>
                </>
              );
            },
          },
        ]),
    ];
  },
  testigo: (
    onEdit: (index: number, invType: string) => void,
    onDelete: (index: number, invType: string) => void,
    readOnly = false
  ) => {
    return [
      {
        ...createColumn({ accessor: 'invNombre', Header: 'Nombre completo' }),
        Cell: ({
          cell: {
            row: { original },
          },
        }: {
          cell: { row: { original: { invNombre: string; invApellido: string } } };
        }) => (
          <>
            {original.invNombre}&nbsp;{original.invApellido}
          </>
        ),
      },
      createColumn({ accessor: 'invPuestoRelacion', Header: 'Puesto' }),
      createColumn({ accessor: 'invUbicacion', Header: 'Ubicación' }),
      createColumn({ accessor: 'invTelMovil', Header: 'Teléfono móvil' }),
      ...(readOnly
        ? []
        : [
          {
            ...createColumn({ accessor: 'customEdit', Header: '' }),
            Cell: ({
              cell: {
                row: { original, index },
              },
            }: {
              cell: { row: { index: number; original: OriginalData } };
            }) => {
              return (
                <>
                  <Button type="submit" variant="link" onClick={() => onEdit(index, original.tipoInvolucrado)}>
                    <FontAwesomeIcon icon={faPen} />
                  </Button>
                  <Button type="submit" variant="link" onClick={() => onDelete(index, original.tipoInvolucrado)}>
                    <FontAwesomeIcon icon={faTrash} color="red" />
                  </Button>
                </>
              );
            },
          },
        ]),
    ];
  },
  afectado: (
    onEdit: (index: number, invType: string) => void,
    onDelete: (index: number, invType: string) => void,
    readOnly = false
  ) => {
    return [
      {
        ...createColumn({ accessor: 'invNombre', Header: 'Nombre completo' }),
        Cell: ({
          cell: {
            row: { original },
          },
        }: {
          cell: { row: { original: { invNombre: string; invApellido: string } } };
        }) => (
          <>
            {original.invNombre}&nbsp;{original.invApellido}
          </>
        ),
      },
      createColumn({ accessor: 'invPuestoRelacion', Header: 'Puesto' }),
      createColumn({ accessor: 'invUbicacion', Header: 'Ubicación' }),
      createColumn({ accessor: 'invTelMovil', Header: 'Teléfono móvil' }),
      ...(readOnly
        ? []
        : [
          {
            ...createColumn({ accessor: 'customEdit', Header: '' }),
            Cell: ({
              cell: {
                row: { original, index },
              },
            }: {
              cell: { row: { index: number; original: OriginalData } };
            }) => {
              return (
                <>
                  <Button type="submit" variant="link" onClick={() => onEdit(index, original.tipoInvolucrado)}>
                    <FontAwesomeIcon icon={faPen} />
                  </Button>
                  <Button type="submit" variant="link" onClick={() => onDelete(index, original.tipoInvolucrado)}>
                    <FontAwesomeIcon icon={faTrash} color="red" />
                  </Button>
                </>
              );
            },
          },
        ]),
    ];
  },
};
